<sg-auto-complete-select
  [placeholder]="placeholder"
  [valueTransform]="valueTransform"
  [formControl]="withFormControl"
  [options]="options"
  [multiple]="multiple"
  [groupBy]="wrappedGroupBy"
  [panelClass]="panelClass"
  [fitContent]="fitContent"
  [appearance]="appearance"
  [overrideArrowIcon]="overrideArrowIcon"
  [isSlimFormField]="isSlimFormField"
  [size]="size"
  [matchTriggerWidth]="matchTriggerWidth"
  [subscriptSizing]="subscriptSizing"
  (openedChange)="openedChange($event)"
  (searchQueryChange)="autoSelectSearchQueryChange($event)"
  (scrollEnd)="scrollEnd()">
  @if (triggerTracker.busy$ | async) {
  <mat-spinner class="project-before-mat-select" diameter="16" mode="indeterminate"></mat-spinner>
  } @if (multiple) {
  <div *sgAutoCompleteSelectTrigger="let ctx">
    @if (ctx.matOption?.length > 0) {
    <span>{{ ctx.matOption[0].viewValue }}</span>
    } @if (ctx.matOption?.length > 1) {
    <span class="example-additional-selection">(+{{ctx.matOption.length - 1}} {{ctx.matOption?.length === 2 ? 'other' : 'others'}})</span>
    }
  </div>
  }
  <ng-container *sgAutoCompleteSelectOption="let ctx">
    <div [class.account-option-selected]="ctx.matOption.selected" [class.account-option-multiple]="ctx.matOption.multiple">{{ ctx.initialValue.label }}</div>
  </ng-container>
  <ng-container *sgAutoCompleteAsyncTemplate>
    @if (tracker.busy$ | async) {
    <mat-progress-bar mode="indeterminate" class="sg-entity-select-progress-bar"></mat-progress-bar>
    }
  </ng-container>
</sg-auto-complete-select>
